import { makeStyle, makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
    gridList: {
        padding: "1rem",
    }, 
    note: {
        mrgin: "1rem",
        padding: "1rem"
    }
}));
